import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { filter, takeUntil, withLatestFrom } from 'rxjs';
import {
  selectOrgSettings,
  selectOrgSettingsSuccess,
} from 'src/app/store/auth/auth.selector';
import { AutoUnsubscribeComponent } from 'src/app/utility/auto-unsubscribe.component';
import {
  formatNavArrayItems,
  getLabelForMenuItem,
  isAppreciateEnabled,
  isNominationEnabled,
  isPostPollEnabled,
  isRewardEnabled,
  isCalendarEnabled,
  isEventsAnnouncementEnabled,
  navItemRedirectionLink,
} from 'src/app/utility/common-logic';
import { OrganizationSettings } from 'src/app/utility/model/organization';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss'],
})
export class TopMenuComponent
  extends AutoUnsubscribeComponent
  implements OnInit
{
  modules = environment.settings.modules;
  navMenuItems: string[] = [];
  orderOfMenuItems = environment.settings.orderOfMenuItems;
  orgSettings: OrganizationSettings;

  isShowAnnouncementEvents = environment.settings.isShowAnnouncementEvents;
  showSettingsInMenu = environment.settings.showSettingsInMenu;

  to = '';

  constructor(
    private store: Store,
    private router: Router,
    private translate: TranslateService,
  ) {
    super();
  }

  ngOnInit() {
    this.store
      .pipe(
        select(selectOrgSettingsSuccess),
        filter((success) => success),
        withLatestFrom(this.store.pipe(select(selectOrgSettings))),
        takeUntil(this.destroy$),
      )
      .subscribe(([_, settings]) => {
        this.orgSettings = settings;
        this.buildMenu();
      });

    this.to = this.router.url.split('/')[1];
  }

  buildMenu() {
    let updatedNavMenuItems: string[] = ['home'];

    if (this.showSettingsInMenu) updatedNavMenuItems.push('settings');

    if (isRewardEnabled(this.orgSettings) && this.modules.rewards)
      updatedNavMenuItems.push('rewards');

    if (this.modules.myWallet) updatedNavMenuItems.push('my-wallet');

    if (this.modules.pointsHistory) updatedNavMenuItems.push('point-history');

    if (
      (isAppreciateEnabled(this.orgSettings) &&
        isNominationEnabled(this.orgSettings)) ||
      isAppreciateEnabled(this.orgSettings)
    ) {
      updatedNavMenuItems.push('appreciate');
    } else if (isNominationEnabled(this.orgSettings)) {
      updatedNavMenuItems.push('nomination');
    }

    if (
      isAppreciateEnabled(this.orgSettings) &&
      updatedNavMenuItems.includes('nomination')
    ) {
      updatedNavMenuItems = updatedNavMenuItems.filter(
        (x) => x !== 'nomination',
      );
    }

    if (
      isPostPollEnabled(this.orgSettings) ||
      isAppreciateEnabled(this.orgSettings)
    ) {
      updatedNavMenuItems.push('feeds');
    }

    if (isCalendarEnabled(this.orgSettings) && !this.isShowAnnouncementEvents) {
      updatedNavMenuItems.push('calendar');
    }

    if (
      (isCalendarEnabled(this.orgSettings) ||
        isEventsAnnouncementEnabled(this.orgSettings)) &&
      environment.settings.showAnnouncementsExplicitly
    ) {
      updatedNavMenuItems.push('announcement');
    }

    if (
      isEventsAnnouncementEnabled(this.orgSettings) &&
      this.isShowAnnouncementEvents
    ) {
      updatedNavMenuItems.push('announcement', 'event');
    }

    this.navMenuItems = formatNavArrayItems(
      this.orderOfMenuItems,
      updatedNavMenuItems,
    );
  }

  label(menu: string) {
    return getLabelForMenuItem(menu, this.translate, this.orgSettings);
  }

  is(to: string) {
    return (
      (to === 'my-wallet' && to === this.router.url.split('/')[2]) ||
      (to === 'announcement' && to === this.router.url.split('/')[2]) ||
      (to === 'event' && to === this.router.url.split('/')[2]) ||
      (to === 'appreciate' && to === this.router.url.split('/')[1]) ||
      this.to === to
    );
  }

  selectedClass(to: string) {
    return this.is(to) ? 'selected' : '';
  }

  fontClass(to: string) {
    return this.is(to) ? 'font-selected' : 'font-unselected';
  }

  async onClickTopMenu(menu: string) {
    this.to = menu;
    const link = navItemRedirectionLink(menu, this.orgSettings);

    if (link[0].startsWith('https')) {
      window.open(link[0], '_blank');
    } else {
      await this.router.navigate(link);
    }
  }
}
